/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnInit,
  Inject,
} from '@angular/core';

export interface UserCardUser {
  id?: number;
  name: string;
  slug?: string;
  avatar_url?: string;
  country?: {
    name?: string;
  };
  points?: number;
  badges?: Array<{ points: number }>;
  current_user_permissions?: {
    follow?: boolean;
  };
}

export interface ProfileBanner {
  url?: string;
}

@Component({
  selector: 'ut-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserCardComponent implements OnInit {
  @Input() user!: UserCardUser;

  profileBanner?: ProfileBanner;
  userPoints: string = '';

  constructor(
    @Inject('UserService') private UserService: any,
  ) {}

  ngOnInit(): void {
    if (this.user) {
      this.calculateAdditionalFields();
    }
  }

  private calculateAdditionalFields(): void {
    // Get profile banner from UserService
    if (this.UserService && this.UserService.getProfileBanner) {
      this.profileBanner = this.UserService.getProfileBanner(this.user);
    }

    // Calculate total points from badges
    if (!this.user.badges) {
      this.user.points = 0;
    } else {
      this.user.points = this.user.badges.reduce((sum, badge) => sum + (badge.points || 0), 0);
    }

    // Format user points display
    this.userPoints = this.user.points ? `${this.user.points}` : '';

    // Set default avatar if not provided
    if (!this.user.avatar_url) {
      this.user.avatar_url = '/utest-static/assets/images/default-avatar.png';
    }
  }

  get canFollow(): boolean {
    return !!(this.user.current_user_permissions && this.user.current_user_permissions.follow);
  }
}
